import { GET_ALL_ENTRIES, GET_ALL_INVESTORS, GET_PAGED_ENTRIES, GET_PAGED_INVESTORS } from "../actions/action.types";

const initialState = {
  allEntries: [],
  allInvestors: [],
  pagedInvestors: [],
  pagedEntries: []
};

const entriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_ENTRIES:
      return {
        ...state,
        allEntries: action.payload
      };
      case GET_ALL_INVESTORS:
      return {
        ...state,
        allInvestors: action.payload
      };
      case GET_PAGED_ENTRIES:
      return {
        ...state,
        pagedEntries: action.payload
      };
      case GET_PAGED_INVESTORS:
      return {
        ...state,
        pagedInvestors: action.payload
      };
    default:
      return state;
  }
};

export default entriesReducer;
